module.exports = __webpack_public_path__ + "static/media/site-logo.b14e76f2.png";